<template>
    <div>
        <div v-if="loading" :class="css"></div>
        <slot v-else-if="error" name="error">
            <div class="alert--error">{{error}}</div>
        </slot>
        <slot v-else/>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class Loader extends Vue {
        @Prop({type: Boolean, default: false})
        loading;
        @Prop({type: Boolean, default: false})
        small;
        @Prop({type: [Boolean, String], default: null})
        error;

        get css() {
            return (this.small) ? 'spinner--small' : 'spinner';
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Loader.vue